import constants from '@/common/constants';
import { checkMenuGuard } from '@/common/utils';

export const routes = [
  {
    path: constants.PATHS.EXPORT_POTENTIAL,
    name: 'export-potential',
    component: () => import('@/app/modules/ExportPotential/views/ExportPotential.vue'),
    props: true,
    beforeEnter: checkMenuGuard,
  },
  {
    path: constants.PATHS.EXPORT_POTENTIAL_MAP,
    name: 'app-export-potential-map',
    component: () => import('@/app/modules/ExportPotential/component/ExportPotentialMap.vue'),
    props: true,
    beforeEnter: checkMenuGuard,
  },
];
